import { useLazyQuery } from '@vue/apollo-composable'
import { queryEnquirePositionAll } from '@/graphql/holdings'
import { HoldingsMutationTypes } from '@/store/modules/holdings/mutations-type'
import { useStore } from 'vuex'
import storage, { StorageType } from '@/utils/storage'

export default function useHolding(params: { exchangeType: string }) {
  const store = useStore()
  const { load, onResult, loading, refetch } = useLazyQuery(queryEnquirePositionAll)

  onResult((res) => {
    const { enquirePositionAll } = res.data
    if (enquirePositionAll.ok) {
      if (params.exchangeType === 'FUND') {
        store.commit(HoldingsMutationTypes.SET_FUND_POS_PAGE_LIST, enquirePositionAll.data)
      } else if (params.exchangeType === 'BOND') {
        store.commit(HoldingsMutationTypes.SET_BOND_POS_PAGE_LIST, enquirePositionAll.data)
      } else if (params.exchangeType === 'STOCK') {
        store.commit(HoldingsMutationTypes.SET_STOCK_POS_PAGE_LIST, enquirePositionAll.data.rows)
      } else if (params.exchangeType === 'SPS') {
        store.commit(HoldingsMutationTypes.SET_SPS_POS_PAGE_LIST, enquirePositionAll.data)
      } else if (params.exchangeType === 'EXTRA') {
        store.commit(HoldingsMutationTypes.SET_EXTRA_POS_PAGE_LIST, enquirePositionAll.data)
      }
    }
  })

  const queryHoldingData = () => {
    const param = {
      exchangeType: params.exchangeType === 'STOCK' ? null : params.exchangeType,
      fundAccount: storage.rcGetItem(StorageType.local, 'userInfo')
    }
    // eslint-disable-next-line
    // @ts-ignore
    load(queryEnquirePositionAll, { filter: param }) || refetch({ filter: param })
  }
  return { queryHoldingData, onResult, loading }
}
